<template>
    <div class="mall">
		<div class="header">
			<BackTitle title="LILY 商城" />
			<div class="header-right">
				<AccountCoin />
			</div>
		</div>

        <div class="main">
            <div class="content">
                <!-- 轮播图 -->
                <div class="mall-swiper-wrapper">
                    <swiper ref="mySwiper" :options="swiperOption" class="mall-swiper">
                        <swiper-slide class="mall-swiper-slide">
                            <img src="./images/swiper-1.png" class="mall-swiper-img">
                        </swiper-slide>
                        <swiper-slide>
                            <img src="./images/swiper-1.png" class="mall-swiper-img">
                        </swiper-slide>
                    </swiper>
                </div>
                <!-- 畅销商品 -->
                <template v-if="bestGoods.length">
                    <GoodsList title="畅销商品" :goodsList="bestGoods" />
                </template>
                <!-- 道具 -->
                <template v-if="propGoods.length">
                    <GoodsList title="道具" :goodsList="propGoods" />
                </template>
                <!-- 小精灵 -->
                <template v-if="elfGoods.length">
                    <GoodsList title="小精灵" :goodsList="elfGoods" />
                </template>
                <!-- 装扮套装 -->
                <template v-if="dressGoods.length">
                    <GoodsList title="装扮套装" :goodsList="dressGoods" />
                </template>
                <!-- 背景皮肤 -->
                <template v-if="bgGoods.length">
                    <GoodsList title="背景皮肤" :goodsList="bgGoods" />
                </template>
            </div>
            <div v-if="limitGoods.length" class="aside">
                <div class="limit-godds-title">
                    <img src="./images/best-goods-title.png" alt="" class="">
                </div>
                <ul class="limit-goods-list">
                    <LimitGoodsItem
                        v-for="item in limitGoods"
                        :key="item.id"
                        :cover="item.cover"
                        :price="item.showPrice"
                        :discountPrice="item.price"
                        :endTime="item.discountEndTime"
                        @click.native="showGoodsDetail(item)"
                    />
                </ul>

                <MallDialog :visible.sync="goodsDetailVisible" title="商品详情" confirmBtnText="兑换" :confirm="buyGoods">
                    <GoodsDetailDialogContent :detail="currentGoods" />
                </MallDialog>
            </div>
        </div>
    </div>
</template>

<script>
import { apiGetProducts } from "@/models/mall"
import BackTitle from "@/components/back-title/BackTitle.vue"
import AccountCoin from "@/components/account-coin/AccountCoin.vue"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
import LimitGoodsItem from "./components/LimitGoodsItem.vue"
import GoodsList from "./components/GoodsList.vue"
import mxGoodsDetail from "./mxGoodsDetail"

export default {
    name: 'Mall',
    mixins: [mxGoodsDetail],
    components: {
        BackTitle,
        AccountCoin,
        swiper,
        swiperSlide,
        LimitGoodsItem,
        GoodsList,
    },
    data() {
        return {
            allGoods: {},
            swiperOption: {
                // 轮播图配置
                // autoplay: true,
                speed: 500,
                // navigation: false,
            },
        }
    },
    computed: {
        // 畅销商品
        bestGoods() {
            return this.allGoods.sellProduct || []
        },
        // 道具商品
        propGoods() {
            return this.allGoods.propProduct || []
        },
        // 小精灵商品
        elfGoods() {
            return this.allGoods.genieProduct || []
        },
        // 装扮套装商品
        dressGoods() {
            return this.allGoods.decorateProduct || []
        },
        // 背景皮肤商品
        bgGoods() {
            return this.allGoods.backgroundProduct || []
        },
        // 限时特价商品
        limitGoods() {
            const now = Date.now()
            const limitGoods = this.allGoods.discountProduct?.filter(item => item.discountEndTime > now)
                .map(item => ({
                    ...item,
                    countDown: now - item.discountEndTime,
                })) || []
            return limitGoods
        },
    },
    methods: {
        async getProducts() {
            const res = await apiGetProducts()
            this.allGoods = res.data
        },
    },
    created() {
        this.getProducts()
    },
}
</script>

<style scoped>
.mall {
	box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
	padding-top: 24px;
	background: url("./images/bg.png") center/cover no-repeat;
    overflow: hidden;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.header-right {
	display: flex;
	align-items: center;
	gap: 28px;
	padding-right: 28px;
}

.main {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: flex-end;
    padding: 32px;
    overflow: hidden;
}
.content {
    box-sizing: border-box;
    flex: 1;
    height: 100%;
    padding: 16px;
    background: #f9e1a3;
    border-radius: 50px;
    box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.23), 0px -1px 1px 0px rgba(217,138,67,0.80) inset; 
    overflow: auto;
}
.content::-webkit-scrollbar {
    display: none;
}

.mall-swiper-wrapper {
    box-sizing: border-box;
    height: 240px;
    padding: 8px;
    background: #fff3d3;
    border-radius: 36px;
}
.mall-swiper {
    width: 100%;
    height: 100%;
    border-radius: 36px;
}
.mall-swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.mall-swiper-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.aside {
    width: 429px;
    margin-left: 16px;
}
.limit-godds-title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    margin-bottom: 16px;
    background: rgba(91,24,8,0.34);
    border-radius: 30px;
}
.limit-godds-title img {
    width: 200px;
}
.limit-goods-list {
    display: flex;
    gap: 14px;
    padding: 0;
    margin: 0;
    list-style: none;
}
</style>